import axios from 'axios';

import { PERFIL } from '../actions/types';

import { setAlert } from './alert';
import { changeLoader } from './loader';

//Perfil
export const obtenerPerfil = () => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    try {
        await dispatch(changeLoader(true));
        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/perfil/obtener`, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: PERFIL.OBTENER,
            payload: res.data.perfil
        });
    } catch (error) {
        await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const guardarPerfil = (perfil) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    }

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/perfil/editar`, perfil, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: PERFIL.EDITAR,
            payload: res.data.perfil
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error) {
        await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}